export const BASE_URL = "https://api.mentorx4u.com/api";

export const generatePublicUrl = (fileName) =>{

    return `https://api.mentorx4u.com/public/${fileName}`;
}
